<template>
    <Menu as="div" class="relative inline-block text-left">
        <div>
            <MenuButton
                v-if="permissionCheck" 
                class="flex items-center text-content-basic-3 hover:text-content-basic-2 focus:outline-none focus:ring-2 focus:ring-primary-3 focus:ring-offset-2 focus:ring-offset-gray-100">
                <span class="sr-only">Open options</span>
                <img v-if="useArrowDown" class="cursor-pointer text-content-basic-2" src="@/assets/img/downArrow.svg" alt="downArrow" />
                <img v-else class="h-4 w-4 cursor-pointer rotate-90" style="fill:#666" src="@/assets/img/option.svg" alt="" />
            </MenuButton>
        </div>
        <transition enter-active-class="transition ease-out duration-100" 
                    enter-from-class="transform opacity-0 scale-95" 
                    enter-to-class="transform opacity-100 scale-100"    
                    leave-active-class="transition ease-in duration-75" 
                    leave-from-class="transform opacity-100 scale-100" 
                    leave-to-class="transform opacity-0 scale-95">
            <MenuItems :class="{ 'bottom-4': dropUp, 'left-6 bottom-[-4.5rem]' : dropRight }" class="absolute right-0 z-10 w-[10rem] origin-top-right rounded-2 bg-white shadow-card ring-1 ring-black/5 focus:outline-none">
                <div class="p-2">
                    <template v-for="(item, idx) in menuItems"  :key="idx">
                        <MenuItem v-slot="{ active }" @click="item.action" v-if="item.visible">
                            <a href="#" :class="[active ? 'bg-background-basic-3 text-content-basic-1 outline-none font-semibold' : 'text-content-basic-2', 'block p-3 font-body-sm-regular rounded-2']">{{ item.label }}</a>
                        </MenuItem>
                    </template>
                </div>
            </MenuItems>
        </transition>
    </Menu>
</template>

<script>
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'

export default {
    components : {
        Menu, MenuButton, MenuItem, MenuItems 
    },
    props : {
        permissionCheck: {
            type: Boolean,
            default : true
        },
        menuItems: {
            type: Array,
        },
        bottomPosition : String,
        dropUp : { type : Boolean, default : false },
        dropRight : { type : Boolean, default : false },
        useArrowDown : { type : Boolean, default : false },
    }
}
</script>